export default {
  setDeepLinkAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setDeepLink", payload)
      resolve()
    })
  }
}
